module.exports = __webpack_public_path__ + "static/img/auto-wireless.18c364a1.png";